<template>
  <div class="body">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Commissioner:wght@400;500;700&display=swap" rel="stylesheet">
    <Header />
    <Hero />
    <Stats />
    <About />
  </div>
</template>

<script>
import Header from '../components/crowdfunding/Header.vue';
import Hero from '../components/crowdfunding/Hero.vue';
import Stats from '../components/crowdfunding/Stats.vue';
import About from '../components/crowdfunding/About.vue';

export default {
  components: {
    Header,
    Hero,
    Stats,
    About,
  },
};
</script>

<style lang="scss" scoped>
  .body {
    --moderate-cyan: hsl(176, 50%, 47%);
    --dark-cyan: hsl(176, 72%, 28%);
    --black: hsl(0, 0%, 0%);
    --dark-gray: hsl(0, 0%, 48%);
    --white: hsl(0, 100%, 100%);

    --ff-default: 'Commissioner', sans-serif;
    --fs-base: 1.2rem;
    --fs-h4: 2rem;
    --fs-h3: 2.5rem;

    --sm-spacer: 2.5rem;
    --bg-spacer: 5rem;

    --border-radius: 0.5rem;

    background-color: lightyellow;
    font-family: var(--ff-default);
    font-size: var(--fs-base);
    text-align: center;
    min-height: 100vh;
  }
</style>
